import config from "@/config/index";
import api from "../../utils/axios-util";
import * as mutation_type from "../mutation-types";
const state = config.PauseCode;
var getters = {

};
const mutations = {

    [mutation_type.CommitNothing]: () => { }
};

const actions = {
    GetSystemSettings: ({ commit },) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/systemconfig`).then(response => {
                    let data1 = JSON.parse(response.data.data[0].location)
                    console.log(data1, "lokoklko", data1.known_language);
                    if (data1.call_transcription === true) {
                        localStorage.setItem("call_transcription", JSON.stringify(data1))
                    }
                    if (response.data.system_config.dnd_check === true) {
                        let config_value = JSON.parse(localStorage.getItem("projectConfig"))
                        config_value.projects[0].config[0].dnd_check = response.data.system_config.dnd_check
                        localStorage.setItem("projectConfig", JSON.stringify(config_value))
                    }
                    commit(mutation_type.CommitNothing, {});
                    delete response.data.data[0].lead_id
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    updateSystemSettings: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {

                const id = payload.id;
                delete payload.id;
                api.put(`/systemconfig/${id}`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};